import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus } from "lucide-react";
import { useState } from "react";

interface ExerciseFormProps {
  onSubmit: (name: string) => void;
}

export const ExerciseForm = ({ onSubmit }: ExerciseFormProps) => {
  const [exerciseName, setExerciseName] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (exerciseName.trim()) {
      onSubmit(exerciseName);
      setExerciseName("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <Input
        value={exerciseName}
        onChange={(e) => setExerciseName(e.target.value)}
        placeholder="Nombre del ejercicio"
        className="bg-white/10 border-white/20 text-white ocean:text-white dark:text-white"
      />
      <Button type="submit" className="bg-primary hover:bg-primary/90 sunset:bg-sunset ocean:bg-ocean forest:bg-forest">
        <Plus className="h-4 w-4" />
      </Button>
    </form>
  );
};